// third-party
import { FormattedMessage } from 'react-intl';

// assets
import SupportIcon from '@mui/icons-material/Support';

// ==============================|| MENU ITEMS - SUPPORT ||============================== //

const support = {
    id: 'support',
    title: <FormattedMessage id="support" />,
    icon: SupportIcon,
    type: 'group',
    url: 'support',
    roles: ['employer']
};

export default support;
